import React, { useEffect, useMemo, useRef, useState } from "react";
import { paginateArticleHtml } from "../lib/articleReaders";
import ReaderControls from "./ReaderControls";

export default function ArticleBodyPager({ html }) {
  const pages = useMemo(() => {
    try {
      return paginateArticleHtml(html);
    } catch {
      return [html];
    }
  }, [html]);
  const [page, setPage] = useState(1);
  const pageTopRef = useRef(null);

  useEffect(() => setPage(1), [html]);

  if (pages.length <= 1) {
    return (
      <div
        className="xs-article-body"
        dangerouslySetInnerHTML={{ __html: html }}
        data-testid="article-body"
      />
    );
  }

  const changePage = (nextPage) => {
    const clamped = Math.min(pages.length, Math.max(1, nextPage));
    setPage(clamped);
    window.requestAnimationFrame(() => pageTopRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }));
  };

  return (
    <section className="xs-text-pager" data-testid="article-text-pager" ref={pageTopRef}>
      <ReaderControls page={page} pageCount={pages.length} onPageChange={changePage} label="Article" />
      <div
        className="xs-article-body xs-text-pager-page"
        dangerouslySetInnerHTML={{ __html: pages[page - 1] }}
        data-testid="article-body"
      />
      <ReaderControls page={page} pageCount={pages.length} onPageChange={changePage} label="Article" />
    </section>
  );
}
